<template>
  <div class="ch_check">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'中文台资讯台'},{name:'中文台资讯台审核'}]"></breadcrumb>
    <div class="ch_check-wrap">
      <div class="ch_check-contain">
        <ch-top-nav></ch-top-nav>
        <div class="ch_check-search_wrap">
          <div class="ch_check-search_left">
              <el-select v-model="channel"
                     @change="searchClient"
                     placeholder="请选择">
            <el-option :value="0" label="中文台"></el-option>
            <el-option :value="1" label="资讯台"></el-option>
          </el-select>
            <el-date-picker
              v-model="searchDate"
              type="daterange"
              @change="dateChange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="ch_check-search_right">
                          <a class="ch_check-table_download"
                 @click="exportExcel()">
                <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                   :icon="['fas', 'level-up-alt']" />导出Excel</a>
            <el-input
            clearable
              prefix-icon="el-icon-search"
              v-model="search"
              @keyup.enter.native="searchClient()"
              placeholder="输入内容回车搜索"
            ></el-input>
          </div>
        </div>
        <div class="ch_check-table-wrap">
            <div class="ch_check-table_title">共
            <span> {{accordWithCount}} </span> 个未审核单位，总计{{totalSum>=0?'增加':'减少'}}<span> {{totalSum>=0?totalSum:-totalSum}} </span>户</div>
          <div class="ch_check-table">
            <table>
              <tr>
                <th>
                  <el-checkbox v-model="checkAll" @change="selectAll"></el-checkbox>
                </th>
                <th>单位</th>
                <th>省</th>
                <th>市</th>
                <th>区</th>
                <th>类别</th>
                <th>用户数</th>
                <th>增量</th>
                <th>说明</th>
                <th>添加日期</th>
                <th>操作</th>
              </tr>
              <tr v-for="(item,index) in clientsList" :key="item.viewId">
                <td>
                  <el-checkbox v-model="checkedList[index]" @change="checkItem"></el-checkbox>
                </td>
                <td>{{item.unitsname}}</td>
                <td>{{item.providName}}</td>
                <td>{{item.cityidName}}</td>
                <td>{{item.countyName}}</td>
                <td>{{item.typeName}}</td>
                <td>{{item.num}}</td>
                <td>{{item.effectNum}}</td>
                <td style="max-width:500px">{{item.describ}}</td>
                <td>{{item.createTime.split('T')[0]}}</td>
                <td>
                  <a  @click="gotoDetail(item.clientId)">查看详情</a>
                </td>
              </tr>
            </table>
          </div>
          <div class="ch_check-footer">
            <el-button @click="clientUpdateAudit()" type="primary" :disabled="buttonDisable" class="ch_check-button">批量审核</el-button>
            <el-pagination
              @current-change="changePage"
              :current-page="page"
              class="ch_check-pagination"
              background
              layout="prev, pager, next"
              :total="listSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
import chTopNav from "@/components/chTopNav";
export default {
  components: {
    breadcrumb,
    chTopNav
  },
  data() {
    return {
      buttonDisable: true,
      page: 1,
      search: "",
      listSize: 0,
      searchDate: "",
      clientsList: [],
      startTime: "",
      endTime: "",
      checkAll: false,
      checkedList: [],
      channel:0,

      accordWithCount:0,
      totalSum:0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        page: this.page,
        pageSize: 10,
        name: this.search,
        startTime: this.startTime,
        endTime: this.endTime,
        channel:this.channel,
      };
      axios
        .post(api.clientsAuditList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取中文台审核列表成功", res.data.result);
            this.clientsList = res.data.result.pageResult.records;
            this.checkAll = false
            for (let i in this.clientsList) {
              this.checkedList[i] = false;
            }
            this.listSize = res.data.result.pageResult.total;
            this.accordWithCount = res.data.result.accordWithCount
            this.totalSum = res.data.result.totalSum
          } else {
            console.log("获取中文台审核列表失败", res.data.result.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    changePage(v) {
      this.page = v;
      this.getList();
    },
    //搜索
    searchClient() {
      this.page = 1;
      this.getList();
    },
    //日期搜索
    dateChange() {
      if (this.searchDate) {
        this.startTime = this.searchDate[0] + "T00:00:00Z";
        this.endTime = this.searchDate[1] + "T24:00:00Z";
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      this.searchClient()
    },
    //全选
    selectAll(v) {
      if (v) {
        this.buttonDisable = false;
        this.checkedList = this.checkedList.map(item => {
          return true;
        });
      } else {
        this.buttonDisable = true;
        this.checkedList = this.checkedList.map(item => {
          return false;
        });
      }
    },
    checkItem(v) {
      if(v){
        this.buttonDisable = false
      } else {
        let check = true
        for(let i of this.checkedList){
          if(i === true) {
            check = false
            break
          }
        }
        this.buttonDisable = check
        if(this.checkAll) {
          this.checkAll = false
        }
      }
    },
    //批量审核
    clientUpdateAudit(){
      let list = []
      for(let i in this.checkedList) {
        if(this.checkedList[i]===true){
          list.push(this.clientsList[i].viewId)
        }
      }
      let params = {
        list:list
      }
      axios
        .post(api.clientUpdateAudit, params)
        .then(res => {
          if (res.data.code === 0) {
           this.$message({
              message: "批量审核成功",
              type: "success"
            });
          this.getList()
          } else {
               this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
     gotoDetail(id) {
      this.$router.push({ path: `/ch_channel/detail/${id}` ,query:{from:'check'}});
    },
    //导出excel
    exportExcel() {
     let params = {
        name: this.search,
        startTime: this.startTime,
        endTime: this.endTime,
            channel:this.channel,
      };
      axios({
        // 用axios发送post请求
        method: 'post',
        url: api.clientAuditExport,
        data: params,
        responseType: 'blob' // 表明返回服务器返回的数据类型
      })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/x-xls' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '中文台/资讯台审核列表.xls'
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
  }
};
</script>

<style lang="scss">
.ch_check {
  min-width: 1255px;
  .ch_check-wrap {
    padding: 77px 30px 0px 30px;
    .ch_check-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .ch_check-search_wrap {
        background: #f8f8f8;
        padding: 20px 27px;
        display: flex;
        .ch_check-search_left {
          display: flex;
          flex: 1;
          .el-select {
          width: 120px;
          margin-right: 13px;
        }
        }
        .ch_check-search_right {
          display: flex;
          .el-input {
          width: 178px;
        }
          .ch_check-table_download {
               cursor: pointer;
                           text-decoration: none;
            width: 108px;
            height: 38px;
            margin-right: 10px;
            border-radius: 4px;
            background: #fff;
            margin-left: 20px;
            border: 1px solid rgba(220, 223, 230, 1);
            color: #9b9b9b;
            font-size: 14px;
            font-weight: 500;
            line-height: 38px;
            text-align: center;
          }
        }
      }
      .ch_check-table-wrap {
        padding: 30px;
        .ch_check-table_title {
          color: #9b9b9b;
          span {
            color: #f0722b;
          }
        }
        .ch_check-table {
          min-height: 470px;
          tr {
            input[type="checkbox" i] {
            }
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;
              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .ch_check-footer {
          margin-top: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .ch_check-button {
          }
        }
      }
    }
  }
}
</style>
